(function () {
  if (customElements.get('free-shipping-bar')) return;

  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      this.update();
      this.hideInjectedBars();

      this.onCartUpdate = this.handleCartUpdate.bind(this);

      document.addEventListener('cart:updated', this.onCartUpdate);

      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const total = event && event.cartData && event.cartData.total_price;
          if (typeof total === 'number') {
            this.dataset.cartTotal = String(total);
            this.update();
            return;
          }
          this.handleCartUpdate();
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdate);
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
    }

    handleCartUpdate() {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          this.dataset.cartTotal = String(cart.total_price);
          this.update();
        })
        .catch(() => {});
    }

    update() {
      const threshold = Number(this.dataset.threshold);
      const cartTotal = Number(this.dataset.cartTotal);
      const messageEl = this.querySelector('[data-free-shipping-bar-message]');
      const fillEl = this.querySelector('[data-free-shipping-bar-fill]');
      const trackEl = this.querySelector('.free-shipping-bar__track');

      if (!threshold || threshold <= 0) {
        this.hidden = true;
        return;
      }

      this.hidden = false;

      const remaining = threshold - cartTotal;
      let message = this.dataset.achievedMessage || '';

      if (remaining > 0) {
        message = String(this.dataset.thresholdMessage || '').replace(
          '[value]',
          this.dataset.thresholdLabel || ''
        );
        if (fillEl) {
          fillEl.style.setProperty(
            '--free-shipping-progress',
            String(Math.min(1, cartTotal / threshold))
          );
        }
      } else if (fillEl) {
        fillEl.style.setProperty('--free-shipping-progress', '1');
      }

      if (messageEl) messageEl.textContent = message;

      if (trackEl) {
        trackEl.setAttribute('aria-valuenow', String(Math.min(cartTotal, threshold)));
        if (message) trackEl.setAttribute('aria-label', message);
      }
    }

    hideInjectedBars() {
      const drawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
      hideAppShippingWidgets(drawer);
    }
  }

  function hideAppShippingWidgets(drawer) {
    if (!drawer) return;

    drawer.querySelectorAll('[role="progressbar"]').forEach((el) => {
      if (el.closest('free-shipping-bar')) return;
      const wrap = el.parentElement;
      if (wrap && wrap !== drawer) wrap.style.setProperty('display', 'none', 'important');
    });

    const copyPattern = /frete\s+gr[aá]tis\s+(acima|aplicado)/i;
    drawer.querySelectorAll('p, span, div, small, strong, label').forEach((el) => {
      if (el.closest('free-shipping-bar')) return;
      if (el.closest('shipping-calculator')) return;
      if (el.closest('.cart-item')) return;
      if (el.closest('.cart__ctas')) return;
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!copyPattern.test(text) || text.length > 80) return;

      let node = el;
      for (let i = 0; i < 3 && node.parentElement; i++) {
        const parent = node.parentElement;
        if (parent === drawer || parent.classList.contains('drawer__inner')) break;
        if (parent.querySelector('cart-drawer-items, .cart-item, .cart-drawer__toolbar, shipping-calculator')) break;
        node = parent;
      }
      if (node.classList.contains('cart-drawer__top') || node.tagName === 'CART-DRAWER') return;
      node.style.setProperty('display', 'none', 'important');
    });
  }

  customElements.define('free-shipping-bar', FreeShippingBar);

  function observeCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.shippingChromeObserved) return;
    drawer.dataset.shippingChromeObserved = 'true';
    hideAppShippingWidgets(drawer);
    const observer = new MutationObserver(() => hideAppShippingWidgets(drawer));
    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartDrawer);
  } else {
    observeCartDrawer();
  }
})();
